import { useSelector } from 'react-redux';

type Paging = {
  sourcesSupported: string[];
  sourcesAllowed: string[];
  sinksSupported: string[];
  sinksAllowed: string[];
  credentialsAllowed: string[];
  metaInfoById: Record<string, any>;
  connAuthById: Record<string, any>;
  connAuthMeta: Record<string, any>;
  sourceConfigById: Record<string, any>;
  sinkConfigById: Record<string, any>;
};

export function useGetPaging(): Paging {
  return useSelector((state: any) => state.paging) as Paging;
}
